import { Audited, ID } from '@ianesthesie-kit/services';

export type NotificationType = 'EMAIL' | 'SMS';
export type NotificationDirection = 'OUTGOING' | 'INCOMING';
export type NotificationStatus =
  | 'PENDING'
  | 'COMPLETED'
  | 'FAILED'
  | 'FAILED_UNVERIFIED';

interface BaseNotification extends Audited {
  toUserId: ID;
  type: NotificationType;
  status: NotificationStatus;
  direction: NotificationDirection;
  message: string;
  sentAt?: string;
  sendAt?: string;
}

export interface PendingNotification extends BaseNotification {
  status: 'PENDING';
  sentAt?: never;
  sendAt?: never;
}

export interface CompletedNotification extends BaseNotification {
  status: 'COMPLETED';
  sentAt: string;
}

export interface FailedNotification extends BaseNotification {
  status: 'FAILED' | 'FAILED_UNVERIFIED';
  sentAt?: never;
  sendAt: string;
}

export type Notification =
  | PendingNotification
  | CompletedNotification
  | FailedNotification;

export const isFailed = (
  status?: NotificationStatus
): status is 'FAILED' | 'FAILED_UNVERIFIED' =>
  status === 'FAILED' || status === 'FAILED_UNVERIFIED';
